



















import { Component, Vue, Prop, State } from 'nuxt-property-decorator'
import Tag from './tag.vue'

@Component({
  components: {
    Tag
  }
})
export default class TagComponent extends Vue {
  @State((state) => state.klook.platform) platform!: Data.Platform
  @Prop({ default: () => [] }) tagList!: any
  @Prop({ default: false }) visible!: boolean

  get valid() {
    return !!this.tagList?.length
  }
}
